import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { restoreAll } from '../restoreAll';
import { RootState } from '..';
import { CountryDto } from '../../commonTypes/country.types';
import { GoogleImportHolidayDto } from '../../commonTypes/organization.types';

export interface ImportHolidaysState {
    formState: 'findHolidays' | 'foundHolidays';
    selectedCountry?: CountryDto;
    selectedYear?: number;
    googleHolidays?: GoogleImportHolidayDto[];
    selectedGoogleHolidays: string[];
    selectedBranches: string[];
}

const initialState: ImportHolidaysState = {
    formState: 'findHolidays',
    selectedGoogleHolidays: [],
    selectedBranches: [],
};

type SetGoogleHolidaysAction = PayloadAction<GoogleImportHolidayDto[]>;
type PrepareToFindHolidaysAction = PayloadAction<{ country: CountryDto; year: number }>;

export const importHolidaysSlice = createSlice({
    name: 'importHolidays',
    initialState,
    extraReducers: builder => builder.addCase(restoreAll, () => initialState),
    reducers: {
        setGoogleHolidays: (state, action: SetGoogleHolidaysAction) => {
            state.googleHolidays = action.payload;
        },
        addSelectedGoogleHolidays: (state, action: PayloadAction<string[]>) => {
            const combinedArrray = state.selectedGoogleHolidays.concat(action.payload);
            const uniqueSet = new Set(combinedArrray);
            state.selectedGoogleHolidays = [...uniqueSet];
        },
        removeSelectedGoogleHoliday: (state, action: PayloadAction<string>) => {
            state.selectedGoogleHolidays = state.selectedGoogleHolidays.filter(holidayId => holidayId !== action.payload);
        },
        clearSelectedHolidays: state => {
            state.selectedGoogleHolidays = [];
        },
        prepareToFindHolidays: (state, action: PrepareToFindHolidaysAction) => {
            state.formState = 'foundHolidays';
            state.selectedCountry = action.payload.country;
            state.selectedYear = action.payload.year;
        },
        setSelectedBranches: (state, action: PayloadAction<string[]>) => {
            state.selectedBranches = action.payload;
        },
        resetImportGoogleHolidaysState: () => initialState,
    },
});

export const {
    setGoogleHolidays,
    prepareToFindHolidays,
    resetImportGoogleHolidaysState,
    addSelectedGoogleHolidays,
    removeSelectedGoogleHoliday,
    clearSelectedHolidays,
    setSelectedBranches,
} = importHolidaysSlice.actions;

export const selectFormState = (state: RootState) => state.importHolidays.formState;

export const selectGoogleHolidays = (state: RootState) => state.importHolidays.googleHolidays;

export default importHolidaysSlice.reducer;
